import { useTranslation } from 'react-i18next';

import { UsageMetric } from './UsageMetric/UsageMetric';

type UsageSectionProps = {
  connectedPartnersCount: number;
  readyConnectionsCount: number;
  usedCredits: number;
  creditAllowance: number;
};

export const UsageSection = ({
  connectedPartnersCount,
  readyConnectionsCount,
  usedCredits,
  creditAllowance,
}: UsageSectionProps) => {
  const { t } = useTranslation();
  const usagePercent = creditAllowance > 0 ? Math.min(100, Math.round((usedCredits / creditAllowance) * 100)) : 0;

  return (
    <section className="grid grid-cols-[320px_1fr] gap-12">
      <div className="flex flex-col gap-2">
        <h3 className="text-base font-bold text-black">{t('settings:usageAndModules.usage.title')}</h3>
        <p className="text-sm text-gray-500">{t('settings:usageAndModules.usage.description')}</p>
      </div>
      <div className="flex flex-col gap-4">
        <UsageMetric
          label={t('settings:usageAndModules.usage.connectedTradePartners')}
          value={connectedPartnersCount}
        />

        <UsageMetric
          label={t('settings:usageAndModules.usage.readyConnections')}
          value={readyConnectionsCount}
          tooltip={t('settings:usageAndModules.usage.readyConnectionsTooltip')}
        />

        <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            <div className="flex flex-col">
              <span className="text-sm font-medium text-gray-900">
                {t('settings:usageAndModules.usage.creditUsage')}
              </span>
              <span className="text-xs text-gray-500">
                {t('settings:usageAndModules.usage.creditUsageCounter', {
                  used: formatCredits(usedCredits),
                  total: formatCredits(creditAllowance),
                })}
              </span>
            </div>
            <div className="flex flex-1 flex-col items-end gap-1">
              <span className="text-2xl font-bold text-gray-900">{usagePercent}%</span>
              <div className="h-1.5 w-full max-w-45 overflow-hidden rounded-full bg-gray-100">
                <div className="h-full rounded-full bg-procuros-green-400" style={{ width: `${usagePercent}%` }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const formatCredits = (credits: number) => Math.round(credits).toLocaleString();
